var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05783 4.35V3.63C6.05783 2.037 6.05783 0.75 9.01183 0.75H10.4878C13.4418 0.75 13.4418 2.037 13.4418 3.63V4.35M6.05783 18.75H13.4418C17.1518 18.75 17.8168 17.3 18.0108 15.537L18.7028 8.337C18.9528 6.141 18.3058 4.35 14.3648 4.35H5.13483C1.19383 4.35 0.547829 6.141 0.796829 8.337L1.48883 15.537C1.68283 17.3 2.34783 18.75 6.05783 18.75Z",
    stroke: "#610D24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56238 11.081C5.21909 10.8225 2.96755 10.0247 0.984375 8.75M11.9844 11.081C14.3277 10.8225 16.5792 10.0247 18.5624 8.75M11.7504 11.25C11.7504 11.7804 11.5397 12.2891 11.1646 12.6642C10.7895 13.0393 10.2808 13.25 9.75037 13.25C9.21994 13.25 8.71123 13.0393 8.33616 12.6642C7.96109 12.2891 7.75037 11.7804 7.75037 11.25C7.75037 10.7196 7.96109 10.2109 8.33616 9.83579C8.71123 9.46071 9.21994 9.25 9.75037 9.25C10.2808 9.25 10.7895 9.46071 11.1646 9.83579C11.5397 10.2109 11.7504 10.7196 11.7504 11.25Z",
    stroke: "#610D24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundSelectedIcon);
export default __webpack_public_path__ + "static/media/fund_selected_icon.3ad000eb694aa38f980cbbd4c6b4c0d2.svg";
export { ForwardRef as ReactComponent };